import classNames from 'classnames'
import { JSX, useCallback, useState } from 'react'

import { INVENTORY_RARITY, InventoryCard,InventoryType } from '@store'

import { InventoryThing } from '../inventoryThing'
import { DragItem } from './DragItem'
import styles from './InventoryCardItem.module.scss'
import { RarityTags } from './rarity-tags/RarityTags'
import { LAST_SPIRAL_BORDER_DEF_IDS } from '@shared'

const EPIC_BORDER_DEF_IDS = ['019c5595-7eb0-754e-acee-b18114b3b141']
const LEGENDARY_BORDER_DEF_IDS = ['019cdd35-d7b5-7e35-a351-657106aff0de']

interface InventoryCardProps {
  type: InventoryType
  card: InventoryCard
  onClick(card: InventoryCard): void
  handleDrop?(card: InventoryCard): void
  onDragStart?(card: InventoryCard): void
  onDragEnd?(card: InventoryCard): void
}

export const InventoryCardItem = ({
  type,
  card,
  onClick,
  handleDrop,
  onDragStart,
  onDragEnd,
}: InventoryCardProps): JSX.Element => {
  const [isDropped, setIsDropped] = useState(false)
  
  const onDrop = useCallback(() => {
    if (type === 'items') {
      return
    }

    setIsDropped(true)
    handleDrop?.(card)
  }, [card, handleDrop, type])
  return (
    <div
      className={classNames(
        styles.inventoryCard,
        styles[`type-${card.type}`],
        type === 'skins' ? styles[`rarity-veginnete-${INVENTORY_RARITY[card.rarity]}`] : '',
        EPIC_BORDER_DEF_IDS.includes(card.defId) ? styles['rarity-veginnete-epic'] : '',
        LEGENDARY_BORDER_DEF_IDS.includes(card.defId) ? styles['rarity-veginnete-legendary'] : '',
        LAST_SPIRAL_BORDER_DEF_IDS.includes(card.defId) ? styles['rarity-veginnete-lastSpiral'] : '',
      )}
    >
      {type === 'items' || type === 'skins' ? (
        <div onClick={() => onClick(card)}>
          <InventoryThing card={card} />
          {type === 'skins' ? <RarityTags rarity={card.rarity} /> : null}
        </div>
      ) : null}
      {!isDropped && type === 'quest' ? (
        <>
          <DragItem
            onDragStart={() => onDragStart?.(card)}
            onDragEnd={() => onDragEnd?.(card)}
            card={card}
            handleDrop={onDrop}
            onClick={() => onClick(card)}
          >
            <InventoryThing card={card} />
          </DragItem>
        </>
      ) : null}
    </div>
  )
}
